/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EContactLogMethod = 'PhoneCall' | 'SMS' | 'Email' | 'Chat';

export const EContactLogMethod = {
    PhoneCall: 'PhoneCall' as EContactLogMethod,
    Sms: 'SMS' as EContactLogMethod,
    Email: 'Email' as EContactLogMethod,
    Chat: 'Chat' as EContactLogMethod
};

